<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "../../../../components/widgets/loader";
import Forms from "../../../../mixins/Forms";
import {Editor, EditorContent, EditorMenuBar} from 'tiptap';
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
} from 'tiptap-extensions';

import axios from 'axios';

/**
 * View ticket note templates component
 */
export default {
  page: {
    title: "Autoresponder Settings",
    meta: [{name: "description", content: appConfig.description}]
  },
  mixins: [Forms],
  components: {Layout, PageHeader, Loader, EditorMenuBar, EditorContent},
  data() {
    return {
      title: "Autoresponder Settings",
      items: [
        {
          text: "Settings",
          href: "#"
        },
        {
          text: "Autoresponder Settings",
          active: true
        }
      ],

      isLoading: false,
      isSaving: false,
      autoresponderSettings: null,
      serverErrors: [],
      editor: null
    };
  },
  computed: {},
  methods: {
    setupEditor() {
      let vm = this;
      this.editor = new Editor({
        extensions: [
          new Blockquote(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({levels: [1, 2, 3]}),
          new BulletList(),
          new OrderedList(),
          new ListItem(),
          new TodoItem(),
          new TodoList(),
          new Bold(),
          new Code(),
          new Italic(),
          new Link(),
          new Strike(),
          new Underline(),
          new History(),
        ]
      })
    },

    loadAutoresponderSettings() {
      let vm = this;
      vm.isLoading = true;
      axios.get(API_BASE + '/settings/autoresponder').then(r => {
        vm.isLoading = false;
        vm.autoresponderSettings = r.data;
        vm.editor.setContent(vm.autoresponderSettings.autoresponder_template);
      }).catch(e => {
        console.log(e);
        vm.isLoading = false;
        vm.setErrors(e);
      });
    },

    saveChanges() {
      let vm = this;
      vm.isSaving = true;

      axios.put(API_BASE + '/settings/autoresponder', {
        ...vm.autoresponderSettings,
        autoresponder_template: vm.editor.getHTML()
      }).then(r => {
        vm.isSaving = false;
        vm.loadAutoresponderSettings();
        this.$notify.success({
          title: 'Success!',
          message: 'Autoresponder settings updated successfully',
        });
      }).catch(e => {
        console.log(e);
        vm.isSaving = false;
        vm.setErrors(e);
      });
    }
  },
  created() {
    this.setupEditor();
    this.loadAutoresponderSettings();
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <errors :error-list="serverErrors"></errors>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div v-if="isLoading" class="text-center">
              <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
            </div>

            <!-- Loaded -->
            <div v-if="!isLoading">

              <!-- Autoresponder enabled -->
              <div class="form-group row">
                <label for="autoresponderEnabled" class="col-form-label col-lg-2">Autoresponder Enabled?</label>
                <div class="col-lg-10">
                  <v-select style="max-width: 300px;"
                            id="autoresponderEnabled"
                            v-model="autoresponderSettings.autoresponder_enabled" :reduce="source => source.value"
                            :options="[{label: 'No', value: false}, {label: 'Yes', value: true}]"></v-select>

                </div>
              </div>
              <!-- / Autoresponder enabled -->

              <!-- Template -->
              <div class="form-group row">
                <label for="autoresponderTemplate" class="col-form-label col-lg-2">Autoresponder Template</label>
                <div class="col-lg-10">
                  <div class="card shadow-none card-action">
                    <div class="card-body pb-0">
                      <editor-content :editor="editor"/>
                    </div>
                    <div class="card-menubar">
                      <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
                        <div class="menubar">

                          <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                             :class="{ 'is-active': isActive.bold() }"
                             @click="commands.bold"
                          >
                            <i class="fas fa-bold"></i>
                          </a>

                          <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                             :class="{ 'is-active': isActive.italic() }"
                             @click="commands.italic"
                          >
                            <i class="fas fa-italic"></i>
                          </a>

                          <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                             :class="{ 'is-active': isActive.strike() }"
                             @click="commands.strike"
                          >
                            <i class="fas fa-strikethrough"></i>
                          </a>

                          <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                             :class="{ 'is-active': isActive.underline() }"
                             @click="commands.underline"
                          >
                            <i class="fas fa-underline"></i>
                          </a>

                          <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                             :class="{ 'is-active': isActive.bullet_list() }"
                             @click="commands.bullet_list"
                          >
                            <i class="fas fa-list-ul"></i>
                          </a>

                          <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                             :class="{ 'is-active': isActive.ordered_list() }"
                             @click="commands.ordered_list"
                          >
                            <i class="fas fa-list-ol"></i>
                          </a>

                          <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                             @click="commands.undo"
                          >
                            <i class="fas fa-undo"></i>
                          </a>

                          <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                             @click="commands.redo"
                          >
                            <i class="fas fa-redo"></i>
                          </a>
                        </div>
                      </editor-menu-bar>
                    </div>
                  </div>
                </div>
              </div>
              <!-- / Template -->

              <div class="row justify-content-end">
                <div class="col-lg-10">
                  <button type="submit" class="btn btn-itg-dark"
                          :disabled="(isLoading||isSaving)"
                          @click.prevent="saveChanges">Save
                  </button>
                </div>
              </div>

            </div>
            <!-- / Loaded -->

          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
